import * as $ from "jquery";
import { IComponent } from "@app/components/IComponent";
import { PageState } from "@app/services";
import * as svgPanZoom from "svg-pan-zoom";
import SVGInject from "@iconfu/svg-inject";

export class SvgControlsComponent implements IComponent {
    private element: Element;
    private pageState: PageState;
    private embed: HTMLElement;

    public attach(element: Element, pageState: PageState, previousState: any) {
        this.element = element;
        this.pageState = pageState;

        //SVGInject($("img", this.element),
        //    {
        //        makeIdsUnique: true,
        //        afterInject: (img, svg) => {
        //            console.log(img, svg);
        //            //svgPanZoom(svg,
        //            //    {
        //            //        zoomEnabled: true,
        //            //        controlIconsEnabled: true,
        //            //        fit: true,
        //            //        center: true
        //            //    });
        //        }
        //    })

        //this.embed = document.createElement("object");
        //this.embed.setAttribute("type", "image/svg+xml");
        //this.embed.setAttribute("data", this.element.getAttribute("data-svgcontrols-url"));

        //this.element.appendChild(this.embed);
        //this.embed.addEventListener("load",() => {
        //    svgPanZoom(this.embed,
        //        {
        //            zoomEnabled: true,
        //            controlIconsEnabled: true,
        //            fit: true,
        //            center: true
        //        });
        //});
        //var svg = $("svg", this.element)[0];
        //console.log(svg);
        //svgPanZoom(svg,
        //    {
        //        zoomEnabled: true,
        //        controlIconsEnabled: true,
        //        fit: true,
        //        center:true
        //    });
    }

    public getState() {
        return null;
    }
}
